import { render, staticRenderFns } from "./VerticalAllMedia.vue?vue&type=template&id=0f4fa4b8"
import script from "./VerticalAllMedia.vue?vue&type=script&lang=js"
export * from "./VerticalAllMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports